"use client";

import type { I18nProviderProps } from "@i18n/react";
import { I18nProvider as I18nProviderReact, IntlErrorCode } from "@i18n/react";

import { consoleErrorI18nNext } from "../utils/consoleErrorI18nNext";

export const I18nProvider = ({
  children,
  isOnErrorMessagesWithUnderscoresOnly,
  ...props
}: I18nProviderProps) => {
  /**
   * Handle errors on messages with underscores ONLY
   */
  if (isOnErrorMessagesWithUnderscoresOnly)
    props.onError = (error) => {
      if (
        error.code === IntlErrorCode.MISSING_MESSAGE &&
        error.originalMessage.includes("_")
      )
        consoleErrorI18nNext({
          heading: `${error.originalMessage} (${error.code})`,
          error: error.message,
        });
    };

  return (
    <I18nProviderReact timeZone="UTC" {...props}>
      {children}
    </I18nProviderReact>
  );
};
